<template>
  <date-time-picker
    :min-date="minDate"
    :max-date="maxDate"
    :prevent-min-max-navigation = "preventMinMaxNavigation"
    :value="value"
    :format="'dd.MM.yyyy'"
    :options="{ enableTimePicker: false }"
    @update:data="(data) => $emit('update:data', data)"
  ></date-time-picker>
</template>

<script>
import DateTimePicker from '@kanrisha/components/Elements/DateTimePicker';

export default {
  components: {
    DateTimePicker,
  },
  props: {
    value: { type: String, default: '' },
    minDate: { type: Number, default: null },
    maxDate: { type: Number, default: null },
    preventMinMaxNavigation: { type: Boolean, default: false },
  },
  emits: ['update:data'],
  setup() {},
};
</script>
